<!-- When using multiple toggle components on the same page, make sure to provide a unique name prop/id value 
-- e.g.   <BaseToggle
              v-model="published" 
              :height=4
              :width=8
              :name="this.survey.id"
              class="h-6 my-auto mr-5"
          />
--
-->
<template>
<div class="relative inline-block align-middle select-none transition duration-200 ease-in" :class="['w-' + width]">
    <input     
    v-bind="$attrs"
    v-on="$listeners"
    :checked="!!value"
    @change="$emit('update', $event.target.checked)"
    :disabled="disabled"
    type="checkbox" :name="name" :id="name" class="toggle-checkbox absolute block rounded-full bg-white border appearance-none cursor-pointer focus:outline-none " :class="['w-' + height, 'h-' + height]"/>    
    <label :for="name" class="toggle-label block overflow-hidden rounded-full bg-gray-300 cursor-pointer" :class="['h-' + height]"></label>
</div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    name: String,
    value: Boolean,
    disabled: Boolean,
    width: {default: 10},
    height: {default: 6}
  },
  model: {
    prop: "value",
    event: "update",
  },
};
</script>

<style scoped>
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #68D391;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #68D391;
}
</style>
